const normalizeAnswerText = (value?: string) =>
	value?.trim().toLocaleLowerCase();

export const isTextAnswerMatch = (userValue?: string, answerWord?: string) => {
	const alternatives = (answerWord ?? "").split("/").map(normalizeAnswerText);
	return alternatives.includes(normalizeAnswerText(userValue));
};
